/**
 * @fileoverview useIsMobile - Mobile breakpoint detection hook
 *
 * Purpose: Detect if viewport is mobile-sized
 * Dependencies: None (uses matchMedia API)
 * Used by: Responsive components, conditional mobile rendering
 *
 * Features:
 * - Detects viewport < 768px
 * - Updates on window resize
 * - SSR-safe (returns undefined initially)
 * - Efficient (uses matchMedia)
 *
 * @returns {boolean} True if mobile viewport
 *
 * @example
 * const isMobile = useIsMobile();
 * return isMobile ? <MobileNav /> : <DesktopNav />;
 */

import * as React from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(
    undefined,
  );

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isMobile;
}
